import http from "../http-common";

class OnboardingExpertDataService {
  createOnboardingExpert(email: any) {
    return http.post(`/onboarding/experts?email=${email}`);
  }
  getOnboardingExperts() {
    return http.get(`/onboarding/experts`);
  }
  getSingleOnboardingExpert(email: any) {
    return http.get(`/onboarding/experts/${email}`);
  }

  updateOnboardingExpert(email: string, data: any) {
    return http.patch(`/onboarding/experts/${email}`, data);
  }
  removeOnboardingExpert(email: string) {
    return http.delete(`/onboarding/experts/${email}`);
  }
}
export default new OnboardingExpertDataService();
